import type { SchemaLedgerEntityStatus } from '@fragment/types/schemas';

export const getAccountStatus = ({
  status,
}: {
  status?: SchemaLedgerEntityStatus | null;
}): SchemaLedgerEntityStatus => {
  return status ?? 'active';
};

export const getEntryStatus = ({
  status,
}: {
  status?: SchemaLedgerEntityStatus | null;
}): SchemaLedgerEntityStatus => {
  return status ?? 'active';
};

export const getEntryTypeVersion = ({
  typeVersion,
}: {
  typeVersion?: number | null;
}): number => {
  return typeVersion ?? 1;
};
